export const TICKET_STATUS_LABELS = {
    new: "New",
    investigating: "Investigating",
    awaiting_reporter: "Awaiting Response",
    duplicate: "Duplicate",
    issue_created: "Issue Created",
    fixing: "Fix In Progress",
    fix_failed: "Fix Failed",
    staging_ready: "Ready for Testing",
    deploying: "Deploying",
    testing: "Testing",
    approved: "Approved",
    merged: "Merged",
    closed: "Closed",
    wont_fix: "Won't Fix",
};
export const SEVERITY_ORDER = {
    critical: 0,
    high: 1,
    medium: 2,
    low: 3,
};
//# sourceMappingURL=ticket.js.map